;(() => {
  const mobileFilterToggle = document.getElementById('mobile-filter-toggle')

  if (mobileFilterToggle) {
    mobileFilterToggle.addEventListener('click', function () {
      document.getElementById('collection-filter-mobile').classList.add('open')
    })

    document
      .querySelectorAll(
        '#collection-filter-mobile-close, #filter-mobile-background'
      )
      .forEach((element) => {
        element.addEventListener('click', function () {
          document
            .getElementById('collection-filter-mobile')
            .classList.remove('open')
        })
      })

    const toggles = document.querySelectorAll('button.filter-toggle-mobile')
    toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        toggle.classList.toggle('active')
        const panel = toggle.nextElementSibling
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px'
        }
      })
    })
  }
})()
